import {
  convertZonetoUTCEnd,
  convertZonetoUTCStart,
} from "../Helper/DatePicker/DateConverter";
import { GetApiResponse, GetData } from "./Functions/SettingData";
import qs from "qs";

export const getIoTState = async (batteryId) => {
  var config = {
    method: "get",
    url: `/api/iot/${batteryId}/state`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
};

export const getIoTAttributeMeta = async () => {
  var config = {
    method: "get",
    url: `/api/iot/attribute_meta`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
};

export const getIoTStateData = async (batteryId) => {
  var config = {
    method: "get",
    url: `/api/iot/${batteryId}/state`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
};

export const downloadIotStateData = async (
  batteryId,
  startDateTime,
  endDateTime
) => {
  var config = {
    method: "get",
    url: `/api/iot/${batteryId}/download`,
    headers: {
      Accept: "text/csv",
    },
    params: {
      startDateTime,
      endDateTime,
    },
    responseType: "blob",
  };

  let data = GetApiResponse(config);
  return data;
};

export const getUnlinkedIotList = async (data) => {
  // Extract iotStatus and testResult as top-level query params, not inside filters JSON.
  // Pass arrays as-is — paramsSerializer with arrayFormat:"repeat" produces ?iotStatus=a&iotStatus=b
  // which Flask's action="append" collects into a list.
  const { iotStatus, testResult, ...otherFilters } = data.filters || {};

  let rawJson = {
    pageCount: data.rowsPerPage,
    pageNum: data.pageNumber,
    sortBy: data?.sortBy ? data?.sortBy : "createdAt",
    order: data?.orderBy ? data?.orderBy : "desc",
  };

  if (iotStatus) rawJson.iotStatus = iotStatus;
  if (testResult) rawJson.testResult = testResult;

  if (Object.keys(otherFilters).length > 0) {
    rawJson.filters = JSON.stringify(otherFilters);
  }

  var config = {
    method: "get",
    url: `/api/iots`,
    headers: { "Content-Type": "application/json" },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let response = GetData(config, true);
  return response;
};

export const manageIotTesting = async (imei, body) => {
  var config = {
    method: "post",
    url: `/api/iots/${imei}/testing`,
    headers: { "Content-Type": "application/json" },
    data: body,
  };

  let response = GetData(config, true);
  return response;
};

export const unlinkedIotListActions = async (data) => {
  var config = {
    method: "post",
    url: `/api/iots/actions`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  let response = GetData(config, true);

  return response;
};

export const iotSearchSuggestions = async (
  search,
  columnName = "imei",
  limit = 5
) => {
  var rawJson = {
    columnName: columnName,
    columnSearch: search,
    columnLimit: limit,
  };
  var config = {
    method: "get",
    url: `/api/iots/search_suggestions`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
};
